const getters = {
    canderCards(state) {
        return state.canderCards;
    },
    addonProducts(state) {
        if (state.configuration?.hasProducts === false) {
            return state.addonProducts.filter(x => x.corporate === true);
        }
        return state.addonProducts;
    },
    totalAddons(state) {
        return state.addonProducts;
    },
    individualProducts(state) {
        return state.selectedIndividualAddons;
    },
    occasions(state) {
        return state.occasions;
    },
    categories(state) {
        return state.categories;
    },
    totalBuildPrice(state) {
        let totalPrice = 0;
        const mainProduct = state.selectedMainProduct;
        const addonProducts = state.selectedAddonProducts;
        const cardProduct = state.selectedCardProduct;

        function priceToInt(product) {
            return parseInt(product.variants[0].price.replace(".", ""));
        }

        function intToPrice(price) {
            return `$${(price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }

        if (mainProduct.variants) {
            totalPrice += priceToInt(mainProduct);
        }

        if (addonProducts.length > 0) {
            addonProducts.forEach(addon => {
                totalPrice += priceToInt(addon) * addon.quantity;
            });
        }

        if (cardProduct.variants) {
            totalPrice += priceToInt(cardProduct);
        }

        return intToPrice(totalPrice);
    },
    //New Getters
    maxCapacity(state) {
        return state.maxCapacity;
    },
    currentCapacity(state) {
        return state.selectedAddonProducts
            .map(x => (x.capacity ? x.capacity * x.quantity : 0))
            .reduce((prev, next) => prev + next, 0);
    },
    selectedAddonProducts(state) {
        return state.selectedAddonProducts;
    },
    boxProducts(state) {
        if (state.configuration?.hasBoxes === false) {
            return state.mainProducts.filter(x => x.corporate === true);
        }
        return state.mainProducts;
    },
    selectedBoxProduct(state) {
        return state.selectedMainProduct;
    },
    cardProducts(state) {
        if (state.configuration?.hasCards === false) {
            return state.cardProducts.filter(x => x.corporate === true || x.id == 7148612419749);
        }
        return state.cardProducts;
    },
    selectedCardProduct(state) {
        return state.selectedCardProduct;
    },
    savedCardProduct(state) {
        return state.savedCardProduct;
    },
    savedKey(state) {
        return state.savedKey;
    },
    selectedOccasion(state) {
        return state.selectedOccasion;
    },
    selectedCategories(state) {
        return state.selectedCategories;
    },
    boxQty(state) {
        return state.boxQty;
    },
    productLimit(state) {
        return state.productLimit;
    },
    selectedSort(state) {
        return state.selectedSort;
    },
    selectedFilters(state) {
        return state.selectedFilters;
    },
    rangePrice(state) {
        return state.rangePrice;
    },
    //Mobile Filter Variables START
    selectedOccasionMobile(state) {
        return state.selectedOccasionMobile;
    },
    selectedCategoriesMobile(state) {
        return state.selectedCategoriesMobile;
    },
    selectedSortMobile(state) {
        return state.selectedSortMobile;
    },
    selectedFiltersMobile(state) {
        return state.selectedFiltersMobile;
    },
    rangePriceMobile(state) {
        return state.rangePriceMobile;
    },
    //Mobile Filter Variables END
    selectedCardsOccasions(state) {
        return state.selectedCardsOccasions;
    },
    selectedCardsOccasionsMobile(state) {
        return state.selectedCardsOccasionsMobile;
    },
    boxName(state) {
        return state.boxName;
    },
    defaulBoxName(state) {
        return state.defaulBoxName;
    },
    cartNames(state) {
        return state.cartNames;
    },
    feeProduct(state) {
        return state.feeProduct;
    },
    addCopy(state) {
        return state.boxQty > 1 ? "Add to Each Box" : "Add to Box";
    },
    cartQty(state) {
        return state.cartQty;
    },
    budget(state) {
        return state.budget;
    },
    currentBudget(state) {
        let total = state.selectedAddonProducts
            .map(x => (x.variants[0].price ? parseInt(x.variants[0].price) * x.quantity : 0))
            .reduce((prev, next) => prev + next, 0);
        if (state.selectedMainProduct) {
            total += parseFloat(state.selectedMainProduct.variants[0].price);
        }
        if (state.selectedCardProduct) {
            total += parseFloat(state.selectedCardProduct.variants[0].price);
        }
        if (state.feeProduct) {
            total += parseFloat(state.feeProduct.variants[0].price / 100);
        }
        return total;
    },
    storefrontHeaderConfig(state) {
        return state.storefrontHeaderConfig;
    },
    corpName(state) {
        return state.corpName;
    },
    messages(state) {
        return state.messages;
    },
    steps(state) {
        if (state.configuration) return state.configuration.steps;

        return [];
    },
    hasBoxes(state) {
        if (state.configuration && state.configuration.hasBoxes != null) {
            return state.configuration.hasBoxes;
        }

        return true;
    },
    hasHBCards(state) {
        if (state.configuration?.hasCards === false) {
            return false;
        }

        return true;
    },
    hasHBProducts(state) {
        if (state.configuration?.hasProducts === false) {
            return false;
        }

        return true;
    },
    hasHPFee(state) {
        if (state.configuration?.hasFee === false) {
            return false;
        }

        return true;
    },
    extraInputs(state) {
        if (state.configuration && state.configuration.extraInputs) {
            return state.configuration.extraInputs;
        }

        return [];
    },
    giftConfiguration(state) {
        if (state.configuration && state.configuration.giftConfiguration) {
            return state.configuration.giftConfiguration;
        }

        return null;
    },
    freeShipping(state) {
        if (state.configuration && state.configuration.freeShipping) {
            return state.configuration.freeShipping;
        }

        return false;
    },
    submittedInputs(state) {
        return state.submittedInputs;
    }
};

export default getters;
